import type { SVGProps } from 'react'
const SvgSyArrowUpSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m13.3 6 7 7 1.8-1.8L12 1 1.9 11.1l1.8 1.8 7-7v17h2.6z" />
	</svg>
)
export default SvgSyArrowUpSystem
